import { Office } from './office';

export class Contacts {
  searchId: string;
  offices: Array<Office>;
  countries: Array<{
    count: number,
    country: {
      name: string,
      id: string
    }
  }>;

  constructor(json: any, accountType = '') {
    this.setOffices(json, accountType);

    try {
      this.countries = json.data.summary.available_countries;

      this.countries.sort((a, b) => {
        let one = a.country.name.toUpperCase();
        let two = b.country.name.toUpperCase();
        return (one < two) ? -1 : (one > two) ? 1 : 0;
      });
    } catch (ex) {
      this.countries = [];
    }
  }

  setOffices(json: any, accountType: string) {
    try {
      this.offices = [];
      for (let current = 0; current < json.data.items.length; current++) {
        let office = new Office(json.data.items[current], accountType);
        this.offices.push(office);
      }
    } catch (ex) {
      this.offices = [];
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/shared/models/contacts.ts